import { X } from "lucide-react";
import React from "react";

import { Box, IconButton } from "@mui/material";

interface CloseIconProps {
  handleClose: () => void;
}
export const CloseIcon = ({ handleClose }: CloseIconProps) => {
  return (
    <Box
      sx={{
        position: "absolute",
        left: "calc(100% - 45px)",
        top: "5px",
      }}
    >
      <IconButton onClick={() => handleClose()}>
        <X size={18} />
      </IconButton>
    </Box>
  );
};
